import { Component, OnInit } from '@angular/core';
import {ExcListConfig} from 'exc-controls';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcTab} from 'exc-tab';
import {ConfigComponent} from '../../config/config.component';
import {ExconClientDetailsComponent} from '../excon-client-details/excon-client-details.component';

@Component({
  selector: 'app-excon-client-list',
  templateUrl: './excon-client-list.component.html',
  styles: []
})
export class ExconClientListComponent extends ExcTranslation implements OnInit {
  clientListConfig: ExcListConfig = new ExcListConfig();
  clientSearchValue = '';
  clientListData: any[] = [];

  constructor(private excrest: ExcRestService) {
  super();
  const _self = this;
    _self.clientListConfig.OnSearch = (searchValue) => {
      _self.clientSearchValue = searchValue;
      _self.loadClients();
    };
    _self.clientListConfig.OnRefresh = (event) => {
      _self.loadClients();
    };
    _self.clientListConfig.OnPageChanged = (pageNo, event) => {
      _self.clientListConfig.paging.pageNo = pageNo;
      _self.loadClients();
    };
    _self.clientListConfig.OnSelectionChanged = (selectedItems, event1) => {
    };
    _self.clientListConfig.selectionMode = 'none';
  }

  ngOnInit() {
    const _self = this;
    _self.loadClients();
  }

  loadClients() {
    const _self = this;
    _self.clientListConfig.isLoading = true;
    const mi = _self.clientListConfig.GetMetaInfo();
    mi['dataSort'] = {'Mdt_KBZ': 'asc'};
    const url = _self.excrest.computeUrl('Excon_ClientR_List', {fts: _self.clientSearchValue});
    _self.excrest.get(url, {MetaInfo: mi})
      .subscribe(response => {
        if (response.data !== undefined) {
          _self.clientListData = response.data;
          _self.clientListData =  response.data;
          _self.clientListConfig.paging = response.paging;
        }
        _self.clientListConfig.isLoading = false;
      });
  }
  showDetails(item) {
      new ExcTab(item.Co_KBZ + '-' + item.Mdt_Kbz, ExconClientDetailsComponent, item, item.Mdt_Id, {Unique: true}, true, 'far fa-university').Open();
  }
}
